import AppFallbackUI from './FallbackUI/AppFallbackUI';
import SceneFallbackUI from './FallbackUI/SceneFallbackUI';

const NotFound = ({ appFallbackUI }) => {
  return appFallbackUI ? <AppFallbackUI /> : <SceneFallbackUI />;
};

export default NotFound;
